var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 5.75V1.25H5.75V5.75H1.25Z",
    stroke: "white",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 14.75V10.25H5.75V14.75H1.25Z",
    stroke: "white",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 5.75V1.25H14.75V5.75H10.25Z",
    stroke: "white",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.5C9 9.22386 9.22386 9 9.5 9H10.84C11.1161 9 11.34 9.22386 11.34 9.5V11.34H9.5C9.22386 11.34 9 11.1161 9 10.84V9.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5C9 15.7761 9.22386 16 9.5 16H10.8362C11.1124 16 11.3363 15.7761 11.3363 15.5V13.6637H9.5C9.22386 13.6637 9 13.8876 9 14.1637V15.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.5C16 9.22386 15.7761 9 15.5 9H14.1638C13.8876 9 13.6637 9.22386 13.6637 9.5V11.3363H15.5C15.7761 11.3363 16 11.1124 16 10.8363V9.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.5C16 15.7761 15.7761 16 15.5 16H14.1638C13.8876 16 13.6637 15.7761 13.6637 15.5V13.6637H15.5C15.7761 13.6637 16 13.8876 16 14.1637V15.5Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.332,
    y: 11.3318,
    width: 2.33625,
    height: 2.33625,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceive);
export default __webpack_public_path__ + "static/media/receive.98c50f32.svg";
export { ForwardRef as ReactComponent };